import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'operation',
  type: 'node--operation',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    testDecimal: {
      type: 'decimal',
      required: false,
      isArray: false,
      name: 'test_decimal',
    },
    created: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'created',
    },
    clientePlazo: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'cliente_plazo_n',
    },
    clienteRenovable: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'cliente_renovable',
    },
    conditioned: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'conditioned',
    },
    draft: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'draft',
    },
    interesDemora: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'interes_demora',
    },
    exclusiva: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'exc',
    },
    formaDevolucion: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'forma_devolucion',
    },
    gestion: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'gestion',
    },
    gestoriza: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'gestoriza',
    },
    honorariosColaborador: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'honorarios_colaborador',
    },
    honorariosIntermediacion: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'honorarios_intermediacion',
    },
    honorariosIntermediacionInmobiliaria: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'honorarios_intermediacion_inmobi',
    },
    clienteImporte: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'importe_cliente',
    },
    nexumImporte: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'importe_ofrecido',
    },
    interesAnual: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'interes_anual',
    },
    interesRenovacion: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'interes_renovacion_nexum',
    },
    inProgress: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'in_progress',
    },
    lastUser: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'last_user',
    },
    ltv: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'ltv',
    },
    motivo: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'motivo',
    },
    perfilCliente: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'perfil_cliente',
    },
    plazoNumero: {
      type: 'integer',
      required: false,
      isArray: false,
      name: 'plazo_n',
    },
    preApproval: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'pre_approval',
    },
    rejected: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'rejected',
    },
    rejectedReason: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'rejected_reason',
    },
    renovable: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'renovable_nexum',
    },
    comisionApertura: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'comision_apertura',
    },
    signed: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'signed',
    },
  },
  relationships: {
    datesAssigments: {
      type: 'node--date_assignement',
      required: false,
      isArray: false,
      name: 'dates_assigments',
    },
    documents: {
      type: 'node--document',
      required: false,
      isArray: true,
      name: 'documents',
    },
    documentsNeeded: {
      type: 'node--document',
      required: false,
      isArray: true,
      name: 'documents_needed',
    },
    clienteCuota: {
      type: 'taxonomy_term--cuotas',
      required: false,
      isArray: false,
      name: 'cliente_cuota',
    },
    cliente_plazo: {
      type: 'taxonomy_term--date',
      required: false,
      isArray: false,
      name: 'cliente_plazo',
    },
    clients: {
      type: 'node--client',
      required: false,
      isArray: true,
      name: 'clients',
    },
    cuota: {
      type: 'taxonomy_term--cuotas',
      required: false,
      isArray: false,
      name: 'cuota',
    },
    notarioCancelacion: {
      type: 'node--notary',
      required: false,
      isArray: false,
      name: 'notario_cancelacion',
    },
    notarioOperacion: {
      type: 'node--notary',
      required: false,
      isArray: false,
      name: 'notario_operacion',
    },
    plazo: {
      type: 'taxonomy_term--date',
      required: false,
      isArray: false,
      name: 'plazo_periodo',
    },
    pledges: {
      type: 'node--pledge',
      required: false,
      isArray: true,
      name: 'pledge',
    },
    prereport: {
      type: 'node--prereport',
      required: false,
      isArray: false,
      name: 'prereport',
    },
    product: {
      type: 'taxonomy_term--product',
      required: false,
      isArray: false,
      name: 'product',
    },
    clienteProducto: {
      type: 'taxonomy_term--product',
      required: false,
      isArray: false,
      name: 'producto_cliente',
    },
    proposal: {
      type: 'taxonomy_term--proposal',
      required: false,
      isArray: false,
      name: 'proposal',
    },
    clienteRango: {
      type: 'taxonomy_term--rango_cargas',
      required: false,
      isArray: false,
      name: 'rango_cliente',
    },
    rango: {
      type: 'taxonomy_term--rango_cargas',
      required: false,
      isArray: false,
      name: 'rango_nexum',
    },
    report: {
      type: 'node--report',
      required: false,
      isArray: false,
      name: 'report',
    },
    state: {
      type: 'taxonomy_term--status',
      required: false,
      isArray: false,
      name: 'state',
    },
    volume: {
      type: 'node--volume',
      required: false,
      isArray: false,
      name: 'volume',
    },
    expenses: {
      type: 'node--expenses',
      required: false,
      isArray: false,
      name: 'expenses',
    },
    provision: {
      type: 'node--provision',
      required: false,
      isArray: false,
      name: 'provision',
    },
    letras: {
      type: 'node--instancia_letra',
      required: false,
      isArray: true,
      name: 'letras_operation',
    },
    cesiones: {
      type: 'node--cesion',
      required: false,
      isArray: true,
      name: 'cesiones',
    },
    fichaComercial: {
      type: 'node--business_card',
      required: false,
      isArray: false,
      name: 'ficha_comercial',
    },
    gestionInmobiliaria: {
      type: 'node--realty_management',
      required: false,
      isArray: false,
      name: 'gestion_inmobiliaria',
    },
  },
};

export const OperationService = createService(base, configuration, API_CONFIG.API);
export const OperationModule = createModule(OperationService, true);



// WEBPACK FOOTER //
// ./src/models/operation.js